import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select } from "antd";
import React, { useState } from "react";
import ReactQuill from "react-quill";

import { api } from "services/api";
import Swal from "sweetalert2";
// import { IAddCourses } from "types";
import { getBase64Img } from "utils";

export const AddModuleModal: React.FC<any> = ({ ...props }) => {
	const [value, setValue] = useState<string>("");
	const [option, setOption] = useState<string>("");
	const [isActive, setIsActive] = useState<boolean>(false);
	const [moduleStatus, setModuleStatus] = useState<boolean>(false);
	const [imageWasAdded, setImageWasAdded] = useState<boolean>(false);

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		currentImgURL,
		courseId,
		setModules,
		titlePage,
	} = props;

	const handleRegister = (values: any) => {
		api
			.post("/modules", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					setModules && setModules(undefined);
					api.get(`/courses/${courseId}/modules`).then((res) => {
						setModules && setModules(res.data.data.modules);
					});
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(!isOpen);
						form.resetFields();
						setValue("");
						setCurrentImgURL("");
						setModuleStatus(false);
						setIsActive(false);
						setOption("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};
	const { Option } = Select;

	return (
		<Modal
			title={<p style={{ margin: 0 }}>{titlePage} - Cadastrar novo módulo</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar módulo"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasAdded
							? {
									...values,
									status: moduleStatus ? "publish" : "pending",
									image: currentImgURL,
									image_to_list: currentImgURL,
									visibility: option,
									is_active: isActive,
									content: value,
									order: "2",
									course_id: `${courseId}`,
							  }
							: {
									...values,
									status: moduleStatus ? "publish" : "pending",
									visibility: option,
									is_active: isActive,
									content: value,
									order: "2",
									course_id: `${courseId}`,
							  };
						handleRegister(allValues);
						console.log(allValues);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				form.resetFields();
				setValue("");
				setCurrentImgURL("");
				setModuleStatus(false);
				setIsActive(false);
				setOption("");
			}}
			className="m-modal-courses"
		>
			<Form form={form} name="new-course" autoComplete="off">
				<div className="m-courses-modal">
					<div className="m-courses-modal__login-info">
						<div className="m-courses-modal__login-info__avatar">
							{currentImgURL ? (
								<img src={currentImgURL} alt="" width="100%" height="100%" />
							) : (
								<FileImageOutlined />
							)}
							<label
								htmlFor="avatar"
								className="m-courses-modal__login-info__avatar__btn"
							>
								Escolha uma foto
							</label>
							<Input
								id="avatar"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onChange={(e) => {
									if (e.target.files?.[0]) {
										setImageWasAdded(true);
										getBase64Img(e.target.files?.[0] as Blob, setCurrentImgURL);
									}
								}}
							/>
						</div>
						<div className="m-courses-modal__login-info__inputs">
							<Form.Item
								name="title"
								rules={[
									{
										required: true,
										message: "Título necessário",
									},
								]}
							>
								<Input placeholder="Título do módulo" />
							</Form.Item>
							<Form.Item
								name="subtitle"
								rules={[
									{
										required: true,
										message: "Subtítulo necessário",
									},
								]}
							>
								<Input placeholder="Subtítulo do módulo" />
							</Form.Item>
							<Form.Item
								name="description"
								rules={[
									{
										required: true,
										message: "Descrição necessário",
									},
								]}
							>
								<Input placeholder="Descrição do módulo" />
							</Form.Item>
						</div>
					</div>
					<div
						style={{ width: "100%", display: "flex", flexDirection: "column" }}
					>
						<div
							style={{
								display: "flex",
								width: "100%",
								alignItems: "center",
								justifyContent: "flex-end",
								marginTop: "15px",
							}}
						>
							<Form.Item
								name="visibility"
								rules={[
									{
										required: true,
										message: "Visibilidade necessária",
									},
								]}
								style={{ width: "24.5%", margin: 0 }}
							>
								<Select
									placeholder="Visibilidade"
									className="m-modules-modal__select"
									onChange={(e) => setOption(e)}
								>
									<Option value="public">Público</Option>
									<Option value="private">Privado</Option>
								</Select>
							</Form.Item>
							<div
								className="m-news-modal__status"
								style={{ margin: "0 10px 0 10px" }}
							>
								<p>Publicado</p>
								<Switch
									checked={moduleStatus}
									onClick={(e) => setModuleStatus(e)}
								/>
							</div>
							<div className="m-news-modal__status">
								<p>Ativo</p>
								<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
							</div>
						</div>
						<div
							className="m-modules-modal__textarea"
							style={{ marginTop: "20px" }}
						>
							<ReactQuill theme="snow" value={value} onChange={setValue} />
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
